export default __webpack_public_path__ + "static/media/fr4.4a2f5694.jpg";